import type { InputProps } from '@chakra-ui/react'
import { Input, InputGroup } from '@chakra-ui/react'
import { formatDisplay, sanitizeRaw } from 'commons/utils/amountHelpers'
import { forwardRef, useState, type ChangeEvent } from 'react'
import { Label } from 'commons/components/layout/Label'
import { useTranslation } from 'react-i18next'

export const AmountInput = forwardRef<HTMLInputElement, InputProps>(({ onChange, value }, ref) => {
	const [raw, setRaw] = useState<string>(String(value || ''))
	const [isFocused, setIsFocused] = useState<boolean>(false)
	const { t } = useTranslation()

	return (
		<>
			<Label>{t('phone_form.amount_label')}</Label>
			<InputGroup>
				<Input
					fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
					fontWeight={500}
					type='text'
					w='full'
					variant='unstyled'
					py={2}
					value={isFocused ? raw : formatDisplay(raw)}
					onChange={(e: ChangeEvent<HTMLInputElement>) => {
						setRaw(sanitizeRaw(e.target.value))
						onChange?.(e)
					}}
					onFocus={() => setIsFocused(true)}
					onBlur={() => setIsFocused(false)}
					ref={ref}
				/>
			</InputGroup>
		</>
	)
})
